import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { tileCss } from '../ui';

const Root = styled(Vertical)<{ background?: string }>`
  ${tileCss}
  align-items: flex-start;
  ${({ background }) =>
    background
      ? css`
          background: ${background};
        `
      : css`
          background: linear-gradient(180deg, #002d81 0%, #0072ee 100%);
        `}
`;

const Title = styled.h3`
  color: var(--c-neutral-1000);
  font: var(--t-48);
  line-height: 1.05;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.96px;
`;

type Props = {
  title: ReactNode;
  background?: string;
  extra?: ReactNode;
};

export const RecommendationTitle = ({ title, background, extra }: Props) => {
  return (
    <Root background={background}>
      <Title>{title}</Title>
      {extra}
    </Root>
  );
};
